module.exports = __webpack_public_path__ + "img/arranges.543edce8.png";